import axios, { AxiosResponse, AxiosPromise } from 'axios';

import { ServerData } from '@/@types/base';

import {
  ApiEmailLoginPayload,
  ApiSocialLoginPayload,
  ApiUserResponse,
  ApiLogoutResponse,
} from '@/@types/auth';

const config = {
  baseURL: process.env.VUE_APP_AUTH_BASE_URL,
};

export async function login(payload: ApiEmailLoginPayload) {
  const response: AxiosResponse<ServerData<ApiUserResponse>> = await axios({
    ...config,
    method: 'POST',
    url: '/login',
    data: payload,
  });

  const {
    data: { success, data: userData },
  } = response;

  if (!success) {
    throw new Error('api login success false');
  }

  return userData;
}

export async function googleLogin(payload: ApiSocialLoginPayload) {
  const response: AxiosResponse<ServerData<ApiUserResponse>> = await axios({
    ...config,
    method: 'POST',
    url: '/google',
    data: payload,
  });

  const {
    data: { success, data: userData },
  } = response;

  if (!success) {
    throw new Error('api googleLogin success false');
  }

  return userData;
}

export async function appleLogin(payload: ApiSocialLoginPayload) {
  const response: AxiosResponse<ServerData<ApiUserResponse>> = await axios({
    ...config,
    method: 'POST',
    url: '/apple',
    data: payload,
  });

  const {
    data: { success, data: userData },
  } = response;

  if (!success) {
    throw new Error('api appleLogin success false');
  }

  return userData;
}

export async function register(payload: ApiEmailLoginPayload) {
  const response: AxiosResponse<ServerData<ApiUserResponse>> = await axios({
    ...config,
    method: 'POST',
    url: '/register',
    data: payload,
  });

  const {
    data: { success, data: userData },
  } = response;

  if (!success) {
    throw new Error('api register success false');
  }

  return userData;
}

type ForgetData = Pick<ApiEmailLoginPayload, 'email'>;

export function forgotPassword(payload: ForgetData): AxiosPromise<ForgetData> {
  return axios({
    ...config,
    method: 'POST',
    url: 'forgot',
    data: payload,
  });
}

export function logout(): AxiosPromise<ServerData<ApiLogoutResponse>> {
  return axios({
    ...config,
    method: 'POST',
    url: 'logout',
  });
}
